import { render, staticRenderFns } from "./AddNewDeposit.vue?vue&type=template&id=4db7be44&scoped=true&"
import script from "./AddNewDeposit.vue?vue&type=script&lang=ts&"
export * from "./AddNewDeposit.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewDeposit.vue?vue&type=style&index=0&id=4db7be44&prod&lang=scss&scoped=true&"
import style1 from "./AddNewDeposit.vue?vue&type=style&index=1&id=4db7be44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db7be44",
  null
  
)

export default component.exports